import { useQuery } from "react-query";
import { ITry2Combo } from "../models/item.model";
import { locationMenuService } from "../services";

interface IQueryParams {
  location_id: string;
  category_id: string;
  item_id: string;
  customer_id?: number | null | undefined;
}

const getTry2Combo = async ({
  location_id,
  category_id,
  item_id, 
  customer_id
}: IQueryParams) => {
  //TODO: Backend need any random item id, Remove it in future when backend will doesn't
  const response = await locationMenuService.getLocationMenuItem({
    item_id: item_id,
    location_id: location_id,
    category_id: category_id,
    customer_id: customer_id
  })
  return response?.data?.data?.categories[0]
};

export default function useTry2Combo(queryParams: IQueryParams) {
  return useQuery<ITry2Combo>(
    ["try2combo", queryParams.category_id],
    () => getTry2Combo(queryParams),{
      enabled: !!(queryParams?.category_id && queryParams?.item_id && queryParams?.location_id ),
  }
  );
}
